import Moe from "./220px-Moe_Szyslak.webp";
import Abe from "./Abraham_Simpson.webp";
import Bart from "./Bart_Simpson.webp";
import Carl from "./Carl_Carlson_-_shading.webp";
import Homer from "./Homer_Simpson.webp";
import Lenny from "./Lenny_Leonard.webp";
import Lisa from "./Lisa_Simpson_official.webp";
import Maggie from "./Maggie_Simpson.webp";
import Marge from "./MargeSimpson.webp";
import Burns from "./Montgomery_Burns.webp";
import Flanders from "./Ned_Flanders.webp";
import Smithers from "./Waylon_Smithers.webp";

const images = {
  Moe,
  Abe,
  Bart,
  Carl,
  Homer,
  Lenny,
  Lisa,
  Maggie,
  Marge,
  Burns,
  Flanders,
  Smithers,
};

export default images;
